import { render, staticRenderFns } from "./DashboardError.vue?vue&type=template&id=adc5d288&scoped=true"
import script from "./DashboardError.vue?vue&type=script&lang=js"
export * from "./DashboardError.vue?vue&type=script&lang=js"
import style0 from "./DashboardError.vue?vue&type=style&index=0&id=adc5d288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc5d288",
  null
  
)

export default component.exports